import { useState } from "react";
import { useRule } from "../CreateRuleNew/RuleReducer";
import Button2 from "../../../Button/Button2";
import { Divider } from "primereact/divider";
import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import classes from "./RuleWizard.module.css";
import Button3 from "../../../Button/Button3";

const Days = ["Mon", "Tues", "Wed", "Thur", "Fri", "Sat", "Sun"];

const WizardStepTrigger = ({ pins, firmware, smartLocks, onNext }) => {
    const { state, dispatch } = useRule();
    const [triggerTime, setTriggerTime] = useState(null);
    const [showTimeTrigger, setShowTimeTrigger] = useState(state.isTimeTrigger);
    const [timeDescriptionVisible, setTimeDescriptionVisible] = useState(false)

    const parts = (firmware || "0.0.0").split(".");
    const [maj, min, rev] = parts.map(Number);
    const supportsOutputPulse = maj > 2 || (maj === 2 && (min > 1 || (min === 1 && rev >= 1)));
    const supportsInputPulse = maj >= 2 || (maj === 1 && min >= 9);

    const handleGeofence = (direction) => {
        dispatch({ type: "SET_IS_GEOFENCE", payload: true });
        dispatch({ type: "SET_IS_TIME_TRIGGER", payload: false });
        dispatch({ type: "SET_GEOFENCE_DIRECTION", payload: direction === "enter" ? "Enter" : "Exit" });
        if (pins.length > 0) {
            dispatch({ type: "SET_DEVICE_UUID", payload: pins[0].DeviceUUID });
        }
        dispatch({ type: "SET_ADV_RULE_ACTION", payload: [] });
        dispatch({ type: "SET_SELECTED_PINS_TO_AFFECT", payload: [] });
        onNext();
    };

    const handleTime = (value) => {
        setTriggerTime(value);
        if (!value) {
            dispatch({ type: "SET_IS_TIME_TRIGGER", payload: false });
            dispatch({ type: "SET_TRIGGER_TIME", payload: null });
            return;
        }
        dispatch({ type: "SET_IS_GEOFENCE", payload: false });
        dispatch({ type: "SET_IS_TIME_TRIGGER", payload: true });
        dispatch({
            type: "SET_TRIGGER_TIME",
            payload: `${String(value.getHours()).padStart(2, "0")}:${String(value.getMinutes()).padStart(2, "0")}`,
        });
        dispatch({ type: "SET_TRIGGER_TIMEZONE", payload: Intl.DateTimeFormat().resolvedOptions().timeZone });
        if (pins.length > 0) {
            dispatch({ type: "SET_DEVICE_UUID", payload: pins[0].DeviceUUID });
        }
    };

    const toggleDay = (dayIndex) => {
        const next = state.days_of_week.includes(dayIndex)
            ? state.days_of_week.filter(d => d !== dayIndex)
            : [...state.days_of_week, dayIndex];
        dispatch({ type: "SET_EXECUTION_DAYS", payload: next });
    };

    const handleToggleTimeTrigger = (checked) => {
        setShowTimeTrigger(checked);
        if (!checked) {
            setTriggerTime(null);
            dispatch({ type: "SET_IS_TIME_TRIGGER", payload: false });
            dispatch({ type: "SET_TRIGGER_TIME", payload: null });
            dispatch({ type: "SET_TRIGGER_TIMEZONE", payload: null });
        }
    };

    const handlePin = (pin) => {
        console.log(pin);
        dispatch({ type: "SET_IS_GEOFENCE", payload: false });
        dispatch({ type: "SET_SELECTED_PIN", payload: pin });
        dispatch({ type: "SET_PIN_NUMBER", payload: pin.Pin });
        dispatch({ type: "SET_IS_LOCK", payload: smartLocks.some(l => parseInt(l.outputPin) === pin.Pin) });
        dispatch({ type: "SET_IS_REGULAR_OUTPUT", payload: smartLocks.every(l => parseInt(l.outputPin) !== pin.Pin) });
        dispatch({ type: "SET_IS_INPUT", payload: pin.type === "INPUT" || pin.type === "VIRTUAL_INPUT" });
        dispatch({ type: "SET_PIN_STATUS_ON", payload: pin.pinStatusOn });
        dispatch({ type: "SET_PIN_STATUS_OFF", payload: pin.pinStatusOff });
        dispatch({ type: "SET_DEVICE_UUID", payload: pin.DeviceUUID });
        dispatch({ type: "SET_SUPPORTS_OUTPUT_PULSE", payload: supportsOutputPulse });
        dispatch({ type: "SET_SUPPORTS_INPUT_PULSE", payload: supportsInputPulse });
        dispatch({ type: "SET_SITE_TYPE", payload: pin.DeviceType });
        dispatch({ type: "SET_PIN_NAME", payload: pin.pinName });
        dispatch({ type: "SET_IS_PULSE", payload: pin.type === "PULSE" || pin.type === "VIRTUAL_PULSE" });

        const condition = {
            condition_type: "STATE_CHECK",
            pin: pin.Pin,
            pin_name: pin.pinName,
            pin_state: pin.type === "PULSE" || pin.type === "VIRTUAL_PULSE" ? "PULSE" : pin.pin_state,
            trigger_method: pin.type === "PULSE" || pin.type === "VIRTUAL_PULSE" ? "PULSE" : "LATCH",
            trigger_method_type: "ANY",
            time_condition: "ANYTIME",
            days_of_week: ["0", "1", "2", "3", "4", "5", "6"],
            is_absence_condition: false,
        };

        dispatch({ type: "SET_ADV_RULE_CONDITION", payload: [condition] });
        dispatch({ type: "SET_CONDITION_EDIT_INDEX", payload: 0 });
        dispatch({ type: "SET_ADV_RULE_ACTION", payload: [] });
        dispatch({ type: "SET_SELECTED_PINS_TO_AFFECT", payload: [] });
        dispatch({ type: "SET_INPUT_TYPE", payload: -1 });
        dispatch({ type: "SET_INPUT_TYPE_COPY", payload: -1 });
        onNext();
    };

    return (
        <>
            <div className={classes.contentHeader}>
                <h2 className={classes.contentTitle}>What triggers this rule?</h2>
                
            </div>
            <div style={{ flex: 1, overflowY: "auto", display: "flex", flexDirection: "column", gap: "20px" }}>
                <div>
                    {/* <div
                        style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer" }}
                        onClick={() => handleToggleTimeTrigger(!showTimeTrigger)}
                    >
                        <Checkbox checked={showTimeTrigger} onChange={() => {}} />
                        <h3 style={{ color: "#6e6e6e", margin: 0, fontSize: "16px", fontWeight: 600 }}>Add time of day as a trigger?</h3>
                        
                    </div>
                    <p style={{ color: "#4f7bff", marginTop: 5, fontSize: "13px", fontWeight: 400, cursor:"pointer"}} onClick={() => setTimeDescriptionVisible(true)}>What's this?</p> */}

                    {showTimeTrigger && (
                        <>
                            <p className={classes.contentSubtitle} style={{ marginTop: "10px" }}>Choose a time for this rule to trigger</p>
                            <br/>
                            <div className={classes.pinGrid}>
                                {/* <Button3 style={{ minWidth: "210px", minHeight: "44px" }} onClick={() => handleGeofence("enter")}>
                                    When first person enters zone
                                </Button3>
                                <Button3 style={{ minWidth: "210px", minHeight: "44px" }} onClick={() => handleGeofence("exit")}>
                                    When last person exits zone
                                </Button3> */}

                                <Calendar
                                    placeholder={"Time"}
                                    value={triggerTime}
                                    onChange={(e) => handleTime(e.value)}
                                    timeOnly
                                    appendTo="self"
                                />
                            </div>

                            <p style={{ color: "#6e6e6e", fontSize: "13px", margin: "14px 0 6px 0" }}>Active on:</p>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
                                {["1", "2", "3", "4", "5", "6", "0"].map((d, i) => (
                                    <Button3
                                        key={i}
                                        style={{
                                            minWidth: "50px", minHeight: "30px", fontSize: "12px",
                                            backgroundColor: state.days_of_week.includes(d) ? "var(--Primary-Color)" : undefined,
                                            color: state.days_of_week.includes(d) ? "white" : undefined,
                                        }}
                                        onClick={() => toggleDay(d)}
                                    >
                                        {Days[i]}
                                    </Button3>
                                ))}
                            </div>
                        </>
                    )}
                </div>

                {showTimeTrigger && (
                    <Divider align="center">
                        <span style={{ color: "#9e9e9e", fontSize: "13px" }}>and</span>
                    </Divider>
                )}

                <div>
                    <h4 style={{ color: "#6e6e6e", margin: "0 0 10px 0", fontSize: "13px", fontWeight: 600 }}>Switch</h4>
                    <p className={classes.contentSubtitle}>{showTimeTrigger ? "Which switch should be checked when the time elapses?" : "Choose a switch to trigger the rule"}</p>
                    <br/>
                    <div className={classes.pinGrid}>
                        {pins.map((pin, i) => (
                            <Button3
                                key={i}
                                style={{ minWidth: "150px", minHeight: "44px" }}
                                onClick={() => handlePin(pin)}
                            >
                                {pin.pinName}
                            </Button3>
                        ))}
                    </div>
                </div>
            </div>

            <Dialog
                header="What does adding a time do?"
                visible={timeDescriptionVisible}
                style={{ width: "34vw" }}
                onHide={() => setTimeDescriptionVisible(false)}
            >
                <p style={{ margin: 0, fontSize: "14px", color: "#3d3d3d", lineHeight: 1.6 }}>
                    Adding a time doesn't replace the switch condition, it adds an extra check on top of it.
                    At the time (and days) you choose, the rule checks whether the switch is still in the state
                    you've set, and only runs its actions if it is.
                </p>
                <p style={{ margin: "12px 0 0 0", fontSize: "14px", color: "#3d3d3d", lineHeight: 1.6 }}>
                    For example: Monday – Friday at 18:00, if CCTV is still disarmed → send alert/take snapshot/switch output state (these actions are chosen in a later step).
                </p>
                <br />
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button label="Got it" severity="success" onClick={() => setTimeDescriptionVisible(false)} />
                </div>
            </Dialog>
        </>
    );
};

export default WizardStepTrigger;
